<!-- Top navbar -->
<lh-navbar-storage-manager></lh-navbar-storage-manager>

<!-- Angular router outlet -->
<router-outlet></router-outlet>

<!-- Bottom tab bar -->
<lh-tab-bar *ngIf="isTabbedNavigationEnabled"></lh-tab-bar>

<!-- Intercom widget -->
<div *ngIf="isIntercomEnabled" id="intercomTrigger" class="intercom-trigger" [hidden]="isTabbedNavigationEnabled">
  <span class="chat-widget-header">{{ 'CHAT_WIDGET_HEADER' | translate }}</span>
</div>
